const TRANSITION_TIME = 100;
const TRANSITION_HALF_TIME = TRANSITION_TIME / 2;

let quizUI;

class QuizUI {
	constructor() {
		this._$quiz = $('.quiz');
		this._$goBackButton = this._$quiz.find('.go-back');

		const $questionContainer = this._$quiz.find('.question-container');
		this._$questionContainer = $questionContainer;
		this._$questionIcon = $questionContainer.find('.question .question-icon');
		this._$questionTitle = $questionContainer.find('.question .question-title');
		this._$questionResultText = $questionContainer.find('.question .question-result-text');
		this._$questionResultSubText = $questionContainer.find('.question .question-result-subtext');
		this._$questionResultVendorTitle = $questionContainer.find('.question .question-text-container .result-vendor-title');

		this._$stepsProgress = this._$quiz.find('.steps-progress');
		this._$stepsProgressNumber = this._$stepsProgress.find('.step-number');
		this._$stepsProgressSlider = this._$stepsProgress.find('.progress');
		this._$stepsProgressContainer = this._$stepsProgress.find('.progress-container');
		this._$stepsProgressPoint = this._$stepsProgress.find('.progress-point');

		this._$answersContainer = this._$quiz.find('.answers-container');

		this._$quizDisclaimer = $('.quiz-disclaimer');

		this._$quizLoader = this._$quiz.find('.quiz-loader');

		this._initHandleQuizResize();
	}

	/**
	 * @returns {jQuery|HTMLElement|Cash}
	 */
	get $quiz() {
		return this._$quiz;
	}

	/**
	 * @return {jQuery|HTMLElement|Cash}
	 */
	get $goBackButton() {
		return this._$goBackButton;
	}

	/**
	 * @return {jQuery|HTMLElement}
	 */
	get $quizDisclaimer() {
		return this._$quizDisclaimer;
	}

	/**
	 * @return {QuizUI}
	 */
	static getInstance() {
		if (!quizUI) {
			quizUI = new QuizUI();
		}
		return quizUI;
	}

	_initHandleQuizResize() {
		const resizeObserver = new ResizeObserver(() => {
			this.updateCssHalfHeightOfTheQuizBlock();
		});

		if (this._$quiz.length) {
			resizeObserver.observe(this._$quiz.get(0));
		}
	}

	/**
	 * @param {QuizQuestion|null} quizQuestion
	 * @param {Number} totalQuestions
	 */
	updateQuestionData(quizQuestion, totalQuestions) {
		if (!quizQuestion) {
			return;
		}

		this._updateQuestion(quizQuestion);
		this._updateStepsProgress(quizQuestion, totalQuestions);
		this._updateAnswers(quizQuestion);
	}

	_updateQuestion(quizQuestion) {
		animate.fadeReplace(
			this._$questionIcon.find('.icon'),
			$('<div class="icon">' + quizQuestion.iconSVG + '</div>'),
		);

		animate.fadeReplace(
			this._$questionTitle.find('.title'),
			$('<div class="title">' + quizQuestion.title + '</div>')
		);
	}

	/**
	 * @param {QuizQuestion} quizQuestion
	 * @param {Number} totalQuestions
	 */
	_updateStepsProgress(quizQuestion, totalQuestions) {
		animate.fadeReplace(
			this._$stepsProgressNumber.find('.number-value'),
			$('<span class="number-value">' + (quizQuestion.stepIndex + 1) + '</span>')
		);

		if (this._$stepsProgressSlider.length > 0) {
			const progressSliderWidth = Math.round((quizQuestion.stepIndex + 1) / totalQuestions) * 100;
			this._$stepsProgressSlider.css('width', progressSliderWidth + '%');
		}

		if (this._$stepsProgressPoint.length > 0) {
			const currentIndex = quizQuestion.stepIndex;
			const nextIndex = currentIndex + 1;

			if (this._$stepsProgressPoint[currentIndex].classList.contains('active')) {
				if (totalQuestions !== nextIndex) {
					this._$stepsProgressPoint[nextIndex].classList.remove('active');
				}
			} else {
				this._$stepsProgressPoint[currentIndex].classList.add('active');
			}
		}
	}

	/**
	 * @param {QuizQuestion} quizQuestion
	 */
	_updateAnswers(quizQuestion) {
		this._showProgress();
		this._hideQuestionResultText();
		animate.fadeReplace(
			this._$answersContainer.find('.answers-holder'),
			this._buildAndGetNewAnswers(quizQuestion)
		);
	}

	_buildAndGetNewAnswers(quizQuestion) {
		const $newAnswers = $('<div class="answers-holder"></div>');

		const answers = Array.isArray(quizQuestion.answers)
			? quizQuestion.answers
			: Object.values(quizQuestion.answers)

		for (const answer of answers) {
			const $newAnswer = $(`<div class="answer">
				<a href="#" class="btn btn-transparent-simple answer-button" 
					data-answer-key="${answer['answer-key']}"
                    data-redirect-to-page="${answer['redirect-to-page']}" >
                    ${answer.title}
				</a>
			</div>`);

			$newAnswers.append($newAnswer);
		}

		return $newAnswers;
	}

	_showProgress() {
		animate.fadeIn(this._$stepsProgress, 0)
	}

	_hideProgress() {
		animate.fadeOut(this._$stepsProgress, 0)
	}

	_showQuestionResultText() {
		this._$questionIcon.addClass('hidden');
		animate.fadeOut(this._$questionTitle, TRANSITION_TIME);
		animate.fadeIn(this._$questionResultText, TRANSITION_TIME);
		animate.fadeIn(this._$questionResultSubText, TRANSITION_TIME);
		this._$questionResultVendorTitle.text($('.quiz-filtered-vendor').attr('data-vendor-title'));
	}

	_hideQuestionResultText() {
		this._$questionIcon.removeClass('hidden');
		animate.fadeIn(this._$questionIcon, 0);
		animate.fadeIn(this._$questionTitle, 0);

		animate.fadeOut(this._$questionResultText, 0);
		animate.fadeOut(this._$questionResultSubText, 0);
	}

	setResultVendorHtml(resultVendorHtml) {
		this._hideProgress();

		const $answerHolder = $('<div class="answers-holder"></div>');
		$answerHolder.html(resultVendorHtml);

		animate.fadeReplace(
			this._$answersContainer.find('.answers-holder'),
			$answerHolder
		);

		this._showQuestionResultText();
	}

	getResultVendor() {
		const $result = this._$answersContainer.find('.quiz-filtered-vendor');
		const resultVendor = $result.length === 1 ? $result : $result[0];

		return $(resultVendor);
	}

	updateCssHalfHeightOfTheQuizBlock() {
		const quizHalfHeight = this._$quiz.length ? this._$quiz.outerHeight() / 2 : null

		if (quizHalfHeight) {
			document.documentElement.style.setProperty('--quiz-half-height', quizHalfHeight + 'px');
		}
	}

	setResultText(text) {
		this._$questionResultText.html(text);
	}

	setResultSubText(text) {
		this._$questionResultSubText.html(text);
	}

	isLoaderEnabled() {
		return this._$quizLoader && this._$quizLoader.length;
	}

	showLoader() {
		if (this.isLoaderEnabled()) {
			this._$answersContainer.addClass('invisible');
			this._$questionContainer.addClass('invisible');
			this._$quizLoader.removeClass('hidden');
		}
	}

	hideLoader() {
		if (this.isLoaderEnabled()) {
			this._$quizLoader.addClass('hidden');
			this._$questionContainer.removeClass('invisible');
			this._$answersContainer.removeClass('invisible');
		}
	}
}
